import angular from 'angular'
import uiRouter from '@uirouter/angularjs'

export default angular.module('app.terminos', [
  uiRouter,
])



// WEBPACK FOOTER //
// ./src/app/terminos/module.js